import { getChatAPI } from '@/api/ChatApi';
import { TableColumn } from '@/models/Table';

export enum NoraToolNames {
  PAPER_QA = 'paper_qa',
  CELL_VALUE_GENERATION = 'table_cell_value_generation',
}

export async function regenerateColumnWithTools(
  column: TableColumn,
): Promise<TableColumn> {
  try {
    const chatApi = getChatAPI();

    const { data } = await chatApi.sendAdhocMessage({
      text: buildColumnToolsQuery(column),
    });
    let retools = data.metadata.tools
      .filter((tool) => tool.kwargs.type === 'tool')
      .map((tool) => tool.kwargs.name)
      .filter((name) => typeof name === 'string') as unknown as string[];

    if (retools.includes(NoraToolNames.PAPER_QA)) {
      retools = [NoraToolNames.CELL_VALUE_GENERATION];
    }

    const updatedColumn: TableColumn = { ...column, tools: retools };

    return updatedColumn;
  } catch (e) {
    console.log('Error regenerating column tools', e);
    return column;
  }
}

const buildColumnToolsQuery = (column: TableColumn): string => {
  const corpusIdWithFullText = 268248445;
  return `Help me figure out the value of one cell in the literature review table. The paper is corpusId ${corpusIdWithFullText}, the column name is "${column.name}" and the description is "${column.description}". Give me the value for this cell only, and be as concise as you can. Do not respond in full sentences unlesss absolutely necessary.`;
};
